export default __webpack_public_path__ + "static/media/6.192f8983.jpg";